<template>
  <BaseIcon :size="size">{{ icon }}</BaseIcon>
</template>
<script lang="ts" setup>
import type { IconSize } from '../base/icon/icon-props'
import BaseIcon from '../base/icon/BaseIcon.vue'
import { computed } from 'vue'

interface Props {
  type: 'to' | 'from' | 'self'
  size?: IconSize
}

const { type, size } = defineProps<Props>()

const icon = computed(() => {
  if (type === 'from') {
    return 'arrow_left_alt'
  } else if (type === 'to') {
    return 'arrow_right_alt'
  } else {
    return 'undo'
  }
})
</script>
